import { spamFilterItems } from "assets/data/filters";
import { posts } from "assets/data/posts";
import { FeedPost, Filter } from "components";
import { useEffect, useState } from "react";
import { FilterSearchCheckItem } from "ui";
import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";
import { checkItem } from "ui/files/others/FilterCheckItem";

const SpamPosts = () => {
    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        }
    ];

    const [openFilter, setOpenFilter] = useState(false);

    // filters
    const toggleItem = (item: checkItem, items: checkItem[]) => {
        const arr: checkItem[] = items.map((i) => {
            if (i.label == item.label) {
                return { label: item.label, checked: !item.checked };
            } else {
                return i;
            }
        });
        return arr;
    };
    // spam
    const [spam, setSpam] = useState("");
    const [spams, setSpams] = useState(spamFilterItems);
    const [filteredSpams, setFilteredSpams] = useState(spamFilterItems);
    const filterAllSpams = () => {
        const arr = spams.filter((c) => c.label.indexOf(spam) > -1);
        setFilteredSpams(arr);
    };

    useEffect(() => {
        filterAllSpams();
    }, [spam, spams]);

    const toggleSpam = (c: checkItem) => {
        const arr = toggleItem(c, spams);
        setSpams(arr);
    };

    // clear all filters
    const clearFilters = () => {
        setSpam("");
        setSpams(spamFilterItems);
    };

    return (
        <section className="w-full h-full flex flex-col relative">
            <div className="w-full text-end lg:hidden bg-neutral-100 dark:bg-momeento-300 px-4 py-2">
                <button
                    className="rounded-full bg-momeento-50 text-white py-1 px-4"
                    onClick={() => setOpenFilter(true)}
                >
                    filter By
                </button>
            </div>
            <div className="w-full h-full flex relative  overflow-auto">
                <div className="w-full flex flex-col lg:w-3/4">
                    <div className="w-full text-center">
                        <Breadcrumb
                            breadcrumb={breadcrumb}
                            currentPath="Spam Posts"
                        />
                        <h1 className="font-medium text-lg dark:text-white py-8">
                            Spam Posts
                        </h1>
                    </div>
                    <div className="w-full items-center flex flex-col gap-10 px-10 ">
                        {/* <IncidentsAreaChart /> */}
                        {posts.map((i) => (
                            <FeedPost post={i} key={i.id} isDeleted />
                        ))}
                    </div>
                </div>
            </div>
            <Filter
                open={openFilter}
                setOpen={setOpenFilter}
                clear={clearFilters}
            >
                <FilterSearchCheckItem
                    title="Spam Type"
                    className="ul-h-full"
                    style={{ height: "95%" }}
                    val={spam}
                    setVal={setSpam}
                    toggleItem={toggleSpam}
                    items={filteredSpams}
                />
            </Filter>
        </section>
    );
};

export default SpamPosts;
